import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Dashboard from "@/pages/Dashboard";
import Stocks from "@/pages/Stocks";
import Orders from "@/pages/Orders";
import Drivers from "@/pages/Drivers";
import Carriers from "@/pages/Carriers";
import Copilote from "@/pages/Copilote";
import Settings from "@/pages/Settings";
import Coaching from "@/pages/Coaching";
import MarketingAssistant from "@/pages/MarketingAssistant";
import Storefront from "@/pages/Storefront";
import ReviewPage from "@/pages/ReviewPage";
import DriverTour from "@/pages/DriverTour";
import OrderTracking from "@/pages/OrderTracking";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import AppLayout from "@/components/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">
        <div className="h-12 w-12 rounded-full border-4 border-[#E85D04]/30 border-t-[#E85D04] animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/connexion" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/connexion" element={<Auth />} />
      <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
      <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
      <Route path="/verifier-email" element={<VerifyEmail />} />
      <Route path="/boutique/:slug/avis" element={<ReviewPage />} />
      <Route path="/livraison/:token" element={<DriverTour />} />
      <Route path="/boutique/:slug" element={<Storefront />} />
      <Route path="/commande/:orderId" element={<OrderTracking />} />
      <Route path="/mentions-legales" element={<Legal page="mentions-legales" />} />
      <Route path="/cgv" element={<Legal page="cgv" />} />
      <Route path="/politique-confidentialite" element={<Legal page="politique-confidentialite" />} />
      <Route path="/politique-remboursement" element={<Legal page="politique-remboursement" />} />
      <Route
        path="/tableau-de-bord"
        element={<Protected><AppLayout><Dashboard /></AppLayout></Protected>}
      />
      <Route path="/stocks" element={<Protected><AppLayout><Stocks /></AppLayout></Protected>} />
      <Route path="/commandes" element={<Protected><AppLayout><Orders /></AppLayout></Protected>} />
      <Route path="/livreurs" element={<Protected><AppLayout><Drivers /></AppLayout></Protected>} />
      <Route path="/transporteurs" element={<Protected><AppLayout><Carriers /></AppLayout></Protected>} />
      <Route path="/copilote" element={<Protected><AppLayout><Copilote /></AppLayout></Protected>} />
      <Route path="/reglages" element={<Protected><AppLayout><Settings /></AppLayout></Protected>} />
      <Route path="/conseils" element={<Protected><AppLayout><Coaching /></AppLayout></Protected>} />
      <Route path="/promouvoir" element={<Protected><AppLayout><MarketingAssistant /></AppLayout></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
